// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__272g9","left":"styles_left__1k1zi","desktopActions":"styles_desktopActions__2nrl9","title":"styles_title__B3psO"};